export default "__VITE_ASSET__c703ebe1__"